// import React, { useEffect, useState } from 'react';
// import { auditAPI } from '../../services/api';
// import { useApp } from '../../contexts/AppContext'; // import useApp
// import '../../BrandPulse.css';
// import { computeOverallScore } from '../../utils/scoreUtils';

// const CACHE_TTL = 24 * 60 * 60 * 1000;

// // Cap value to 0–100 range
// const cap = (v) => Math.min(Math.max(parseInt(v) || 0, 0), 100);

// // ─────────────────────────────────────────────────────────────
// // Extract the flat metrics object from ANY response shape
// // ─────────────────────────────────────────────────────────────
// const extractMetrics = (response, domain) => {
//   if (!response) return null;

//   const d = response?.data;
//   if (!d) return null;

//   // Shape 1 — flat: response.data = { domain_authority, ... }
//   // Shape 2 — wrapped: response.data.data = { domain_authority, ... }
//   // ✅ Checked FIRST — confirmed by diagnostic that data lives here
//   if (d.data?.domain_authority !== undefined) {
//     console.log('[Authority] Shape 2: response.data.data');
//     return d.data;
//   }

//   // Shape 1 — flat: response.data = { domain_authority, ... }
//   if (d.domain_authority !== undefined) {
//     console.log('[Authority] Shape 1: response.data (flat)');
//     return d;
//   }

//   // Shape 3 — keyed by domain: response.data.data["thistle.media"] = { ... }
//   if (d.data && typeof d.data === 'object') {
//     if (d.data[domain]?.domain_authority !== undefined) {
//       console.log(`[Authority] Shape 3: response.data.data["${domain}"]`);
//       return d.data[domain];
//     }
//     // Try first non-insights key
//     const key = Object.keys(d.data).find(k => k !== 'insights' && d.data[k]?.domain_authority !== undefined);
//     if (key) {
//       console.log(`[Authority] Shape 3b: response.data.data["${key}"]`);
//       return d.data[key];
//     }
//   }

//   // Shape 4 — keyed at top level: response.data["thistle.media"] = { ... }
//   if (d[domain]?.domain_authority !== undefined) {
//     console.log(`[Authority] Shape 4: response.data["${domain}"]`);
//     return d[domain];
//   }

//   // Shape 5 — success wrapper: response.data = { success, data: { ... } }
//   if (d.success && d.data) {
//     const inner = d.data;
//     if (inner.domain_authority !== undefined) {
//       console.log('[Authority] Shape 5: response.data.data (success wrapper)');
//       return inner;
//     }
//     if (inner[domain]?.domain_authority !== undefined) {
//       console.log(`[Authority] Shape 5b: response.data.data["${domain}"]`);
//       return inner[domain];
//     }
//   }

//   console.warn('[Authority] Could not find metrics. Full response.data:', JSON.stringify(d));
//   return null;
// };

// // Badge helpers
// const daBadge = (v) => {
//   if (v >= 60) return { label: 'Strong',  cls: 'bup' };
//   if (v >= 40) return { label: 'Good',    cls: 'pg2' };
//   if (v >= 20) return { label: 'Average', cls: 'bok' };
//   return              { label: 'Weak',    cls: 'bb'  };
// };
// const spamBadge = (risk) => {
//   const r = (risk ?? '').toLowerCase();
//   if (r.includes('low'))    return { label: '✓ Low Risk',    cls: 'bup' };
//   if (r.includes('medium')) return { label: '⚠ Medium Risk', cls: 'bok' };
//   if (r.includes('high'))   return { label: '✗ High Risk',   cls: 'bb'  };
//   return                           { label: 'Unknown',        cls: 'bok' };
// };
// const ageBadge = (y) => {
//   if (y >= 5) return { label: 'Mature',  cls: 'bup' };
//   if (y >= 2) return { label: 'Growing', cls: 'bok' };
//   return             { label: 'New',     cls: 'bb'  };
// };
// const blBadge = (n) => {
//   if (n >= 10000) return { label: 'Strong', cls: 'bup' };
//   if (n >= 1000)  return { label: 'Medium', cls: 'bok' };
//   return                 { label: 'Low',    cls: 'bb'  };
// };

// const DomainAuthorityPage = () => {
//   const { setLastAuditInfo, lastAuditInfo } = useApp(); // get setter and current info
//   const [data, setData]         = useState(null);
//   const [loading, setLoading]   = useState(true);
//   const [error, setError]       = useState('');
//   const [refreshing, setRefreshing] = useState(false);

//   const fetchData = async (forceRefresh = false) => {
//     try {
//       // Get URL from localStorage
//       const stored = localStorage.getItem('auditFormData');
//       if (!stored) throw new Error('No audit data. Please complete the form first.');

//       const formData   = JSON.parse(stored);
//       const websiteUrl = formData.websiteUrl || formData.BrandURL || formData.domain || '';
//       if (!websiteUrl) throw new Error('No website URL found in audit data.');

//       // Clean domain for cache key + response parsing
//       const domain = websiteUrl
//         .replace(/^https?:\/\//, '')
//         .replace(/^www\./, '')
//         .split('/')[0]
//         .toLowerCase()
//         .trim();

//       const cacheKey = `domainAuthority_${domain}`;
//       const now = Date.now();

//       // Check local cache
//       if (!forceRefresh) {
//         try {
//           const cached = localStorage.getItem(cacheKey);
//           if (cached) {
//             const { ts, d } = JSON.parse(cached);
//             if (now - ts < CACHE_TTL) {
//               console.log('[Authority] Loaded from localStorage cache');
//               setData(d);
//               updateGlobalContext(d, formData);
//               setLoading(false);
//               return;
//             }
//           }
//         } catch (_) {}
//       }

//       // Call API
//       console.log('[Authority] Calling API for:', websiteUrl);
//       const response = await auditAPI.authorityAnalysis({ BrandURL: websiteUrl,force_refresh: forceRefresh, });
//       console.log('[Authority] Raw response.data:', JSON.stringify(response?.data));

//       // Extract metrics using universal extractor
//       const raw = extractMetrics(response, domain);
//       if (!raw) throw new Error('Could not parse authority metrics from API response. Check console for details.');

//       // Normalize into safe shape
//       const normalized = {
//         domain:           raw.domain           ?? domain,
//         domain_authority: cap(raw.domain_authority),
//         page_authority:   cap(raw.page_authority),
//         spam_score:       cap(raw.spam_score),
//         spam_risk:        raw.spam_risk         ?? 'UNKNOWN',
//         referring_domains: parseInt(raw.referring_domains) || 0,
//         total_backlinks:   parseInt(raw.total_backlinks)   || 0,
//         domain_age_years:  parseFloat(raw.domain_age_years) || 0,
//         source:           raw.source            ?? 'unknown',
//         insights:         raw.insights          ?? '',
//         spam_signals: {
//           backlink_ratio:     raw.spam_signals?.backlink_ratio     ?? 0,
//           ref_domain_quality: raw.spam_signals?.ref_domain_quality ?? 0,
//           domain_age:         raw.spam_signals?.domain_age         ?? 0,
//           anchor_spam:        raw.spam_signals?.anchor_spam        ?? 0,
//           domain_diversity:   raw.spam_signals?.domain_diversity   ?? 0,
//         },
//       };

//       console.log('[Authority] Normalized data:', normalized);

//       // Save to cache
//       localStorage.setItem(cacheKey, JSON.stringify({ ts: now, d: normalized }));
//       setData(normalized);
//       updateGlobalContext(normalized,formData)
//     } catch (err) {
//       console.error('[Authority] Error:', err);
//       setError(err.message || 'Failed to load authority metrics.');
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   };

//   // Helper to update global context with the authority metrics
//   const updateGlobalContext = (metrics, formData) => {
//   // ✅ Read fresh from localStorage — avoids stale closure
//   let current = {};
//   try {
//     const saved = localStorage.getItem('lastAuditInfo');
//     if (saved) current = JSON.parse(saved);
//   } catch (_) {}
  
//   // ✅ Skip recomputation if overall score already exists
//   if (current.overallScore !== undefined && current.overallScore !== null) {
//     return;
//   }
  
//   const prev = current?.scoreInputs || {};

//   const scoreInputs = {
//     ...prev,                          // keep fields set by other pages
//     domainAuthority:  metrics.domain_authority  ?? 0,
//     spamScore:        metrics.spam_score        ?? 99,
//     domainAgeYears:   metrics.domain_age_years  ?? 0,
//     referringDomains: metrics.referring_domains ?? 0,
//   };

//   const overallScore = computeOverallScore(scoreInputs);

//   // ✅ Log so you can verify it's computing correctly
//   console.log('[Authority] scoreInputs:', scoreInputs);
//   console.log('[Authority] overallScore:', overallScore);

//   setLastAuditInfo({
//     ...current,
//     brandName:    formData?.brandName    || current?.brandName    || 'Your Brand',
//     domain:       formData?.websiteUrl   || current?.domain       || '',
//     location:     formData?.locations?.[0]?.city || current?.location || '',
//     auditDate:    current?.auditDate     || new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' }),
//     scoreInputs,
//     overallScore,
//   });
// };
//   //   // Calculate overall score (average of DA and PA, capped 0-100)
//   //   const overallScore = Math.round((metrics.domain_authority + metrics.page_authority) / 2);
//   //   // Get competitor count from stored formData (or fallback to previous lastAuditInfo)
//   //   const competitorCount = formData.competitors?.length || lastAuditInfo?.competitorCount || 0;
//   //   const auditDate = lastAuditInfo?.auditDate || new Date().toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
//   //   const brandName = formData.brandName || lastAuditInfo?.brandName || 'Your Brand';
//   //   const location = formData.locations?.[0]?.city || lastAuditInfo?.location || 'Unknown';
//   //   const industry = formData.industry || lastAuditInfo?.industry || 'Digital Marketing';

//   //   setLastAuditInfo({
//   //     brandName,
//   //     domain: formData.websiteUrl,
//   //     industry,
//   //     location,
//   //     competitorCount,
//   //     overallScore,
//   //     auditDate,
//   //   });
//   // };

//   useEffect(() => { fetchData(); }, []);

//   const handleRefresh = () => { setRefreshing(true); fetchData(true); };

//   if (loading)  return <div className="pad">Loading authority metrics...</div>;
//   if (error)    return (
//     <div className="pad">
//       <div className="error" style={{ marginBottom: 12 }}>{error}</div>
//       <button className="refresh-btn" onClick={handleRefresh}>Retry</button>
//     </div>
//   );
//   if (!data) return <div className="pad">No data available.</div>;

//   const da   = daBadge(data.domain_authority);
//   const pa   = daBadge(data.page_authority);
//   const spam = spamBadge(data.spam_risk);
//   const age  = ageBadge(data.domain_age_years);
//   const bl   = blBadge(data.total_backlinks);
//   const rd   = blBadge(data.referring_domains);
  
//   if (loading) return (
//       <div style={{ textAlign: 'center', padding: '40px' }}>
//         <div>⏳ Running audit... this may take 2–3 minutes</div>
//         <div style={{ fontSize: '12px', color: '#888', marginTop: '8px' }}>
//           Please wait, do not refresh the page
//         </div>
//       </div>
//     );

//     if (error) return <div className="pad error">{error}</div>;
//     if (!data)  return <div className="pad">No data available.</div>;

//   return (
//     <div id="report-content" className="report-container">
//       <div className="pad">

//         {/* Header */}
//         <div className="sec-hd">
//           <div className="sec-ey">Brand Audit</div>
//           <div className="sec-ti">Domain & Authority</div>
//           <div className="sec-ds">
//             Metrics for <strong>{data.domain}</strong>
//           {/* {data.source && (
//               <span style={{ marginLeft: 8, fontSize: 11, color: 'var(--text3)', background: 'var(--surface2)', padding: '2px 8px', borderRadius: 10 }}>
//                 via {data.source}
//               </span>
//             )}*/}
//           </div>
//           <button onClick={handleRefresh} disabled={refreshing} className="refresh-btn">
//             {refreshing ? 'Refreshing...' : '↻ Refresh'}
//           </button>
//         </div>

//         {/* 4 stat cards */}
//         <div className="g4">
//           {[
//             { label: 'Brand Authority', val: data.domain_authority, sub: 'out of 100', color: '#2563eb', badge: da, showBar: true },
//             { label: 'Page Authority',   val: data.page_authority,   sub: 'out of 100', color: '#059669', badge: pa, showBar: true },
//             { label: 'Spam Score',       val: `${data.spam_score}%`, sub: spam.label,   color: '#d97706', badge: spam, showBar: true, barVal: data.spam_score },
//             { label: 'Domain Age',       val: data.domain_age_years, sub: 'years',      color: '#7c3aed', badge: age, showBar: false },
//           ].map(({ label, val, sub, color, badge, showBar, barVal }) => (
//             <div key={label} className="stat">
//               <div className="stat-bar" style={{ background: color }} />
//               <div className="stat-lbl">{label}</div>
//               <div className="stat-val" style={{ color }}>{val}</div>
//               <div className="stat-sub">{sub}</div>
//               <div className={`stat-badge ${badge.cls}`}>{badge.label}</div>
//               {showBar && (
//                 <div className="stat-prog">
//                   <div className="stat-fill" style={{
//                     width: `${typeof val === 'string' ? barVal ?? parseInt(val) : val}%`,
//                     background: color,
//                   }} />
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Metrics table */}
//         <div className="card" style={{ marginTop: 20 }}>
//           <div className="card-ti">Domain Metrics</div>
//           <table className="tbl">
//             <thead>
//               <tr><th>Parameter</th><th>Value</th><th>Status</th></tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td className="fc">Domain Authority (DA)</td>
//                 <td>{data.domain_authority} / 100</td>
//                 <td><span className={`pill ${da.cls}`}>{da.label}</span></td>
//               </tr>
//               <tr>
//                 <td className="fc">Page Authority (PA)</td>
//                 <td>{data.page_authority} / 100</td>
//                 <td><span className={`pill ${pa.cls}`}>{pa.label}</span></td>
//               </tr>
//               <tr>
//                 <td className="fc">Spam Score</td>
//                 <td>{data.spam_score}%</td>
//                 <td><span className={`pill ${spam.cls}`}>{spam.label}</span></td>
//               </tr>
//               <tr>
//                 <td className="fc">Total Backlinks</td>
//                 <td>{data.total_backlinks.toLocaleString()}</td>
//                 <td><span className={`pill ${bl.cls}`}>{bl.label}</span></td>
//               </tr>
//               <tr>
//                 <td className="fc">Referring Domains</td>
//                 <td>{data.referring_domains.toLocaleString()}</td>
//                 <td><span className={`pill ${rd.cls}`}>{rd.label}</span></td>
//               </tr>
//               {/* <tr>
//                 <td className="fc">Domain Age</td>
//                 <td>{data.spam_signals.domain_age} years</td>
//                 <td><span className={`pill ${age.cls}`}>{age.label}</span></td>
//               </tr> */}
//               {/* Inside the table body */}
//               <tr>
//               <td className="fc">Domain Age</td>
//               <td>
//                   {data.domain_age_years > 0 
//                   ? `${data.domain_age_years} years` 
//                   : `${data.spam_signals?.domain_age || 0} years (estimated)`}
//               </td>
//               <td>
//                   <span className={`pill ${data.domain_age_years > 5 ? 'pg2' : 'pw'}`}>
//                   {data.domain_age_years > 5 ? 'Mature' : 'Young'}
//                   </span>
//               </td>
//               </tr>
//             </tbody>
//           </table>

//           {/* Spam signals */}
//           {/* {data.spam_signals && Object.values(data.spam_signals).some(v => v > 0) && (
//             <div style={{ marginTop: 16 }}>
//               <div className="card-ti" style={{ marginBottom: 10, fontSize: 12 }}>Spam Signal Breakdown</div>
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 8 }}>
//                 {[
//                   { label: 'Backlink Ratio',   val: data.spam_signals.backlink_ratio     },
//                   { label: 'Domain Quality',   val: data.spam_signals.ref_domain_quality },
//                   { label: 'Age Score',        val: data.spam_signals.domain_age         },
//                   { label: 'Anchor Spam',      val: data.spam_signals.anchor_spam        },
//                   { label: 'Diversity',        val: data.spam_signals.domain_diversity   },
//                 ].map(({ label, val }) => (
//                   <div key={label} style={{ background: 'var(--surface2)', borderRadius: 8, padding: '10px 12px', border: '1px solid var(--border)', textAlign: 'center' }}>
//                     <div style={{ fontSize: 10, color: 'var(--text3)', marginBottom: 4 }}>{label}</div>
//                     <div style={{ fontSize: 18, fontWeight: 700, color: val > 5 ? 'var(--red)' : 'var(--green)' }}>{val}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )} */}

//           {/* AI Insight */}
//           {data.insights && (
//             <div className="insight" style={{ marginTop: 16 }}>
//               <div className="ins-lbl">✦ AI Insight</div>
//               <div className="ins-txt">{data.insights}</div>
//               <div className="ins-tags">
//                 <span className="itag ih">⚡ High Priority</span>
//                 <span className="itag im">Link Building</span>
//               </div>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default DomainAuthorityPage;

// // src/components/BrandAudit/Step5_SEOTable.jsx
// import React, { useState, useEffect } from 'react';

// const CACHE_TTL = 24 * 60 * 60 * 1000;

// // Helper: clean domain (same as wizard)
// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// // Helper: get authority data from cache
// const getAuthorityData = (domain) => {
//   const cacheKey = `domainAuthority_${domain}`;
//   const cached = localStorage.getItem(cacheKey);
//   if (cached) {
//     const { ts, d } = JSON.parse(cached);
//     if (Date.now() - ts < CACHE_TTL) return d;
//   }
//   return null;
// };

// // Helper: determine dot class based on metric value
// const getMetricClass = (metric, value) => {
//   if (metric === 'da' || metric === 'pa') {
//     if (value >= 40) return 'dot-good';
//     if (value >= 25) return 'dot-warn';
//     return 'dot-bad';
//   }
//   if (metric === 'spam') {
//     if (value <= 3) return 'dot-good';
//     if (value <= 6) return 'dot-warn';
//     return 'dot-bad';
//   }
//   if (metric === 'backlinks') {
//     if (value >= 2000) return 'dot-good';
//     if (value >= 500) return 'dot-warn';
//     return 'dot-bad';
//   }
//   if (metric === 'refDomains') {
//     if (value >= 100) return 'dot-good';
//     if (value >= 40) return 'dot-warn';
//     return 'dot-bad';
//   }
//   if (metric === 'age') {
//     if (value >= 5) return 'dot-good';
//     if (value >= 2) return 'dot-warn';
//     return 'dot-bad';
//   }
//   return 'dot-warn';
// };

// const avatarColors = ['#6B4FA0', '#E05C4B', '#0D9488', '#1A73E8', '#C47D1A'];

// const DomainAuthorityPage = ({ brandName, websiteUrl, competitors, onContinue }) => {
//   const [loading, setLoading] = useState(true);
//   const [rows, setRows] = useState([]);
//   const [insightText, setInsightText] = useState('');

//   // Check if all required authority data is available
//   const isDataReady = () => {
//     const brandDomain = cleanDomain(websiteUrl);
//     if (!getAuthorityData(brandDomain)) return false;
//     for (const comp of competitors) {
//       const compDomain = cleanDomain(comp.website);
//       if (compDomain && !getAuthorityData(compDomain)) return false;
//     }
//     return true;
//   };

//   // Build rows and compute winners
//   const buildTable = () => {
//     const brandDomain = cleanDomain(websiteUrl);
//     const brandData = getAuthorityData(brandDomain);
//     const allRows = [
//       {
//         domain: brandDomain,
//         name: brandName,
//         isBrand: true,
//         color: avatarColors[0],
//         ...brandData,
//       },
//       ...competitors.map((comp, idx) => {
//         const domain = cleanDomain(comp.website);
//         const data = getAuthorityData(domain);
//         return {
//           domain,
//           name: comp.name || domain || 'Competitor',
//           isBrand: false,
//           color: avatarColors[(idx + 1) % avatarColors.length],
//           ...data,
//         };
//       }),
//     ].filter(row => row.domain); // filter out rows with missing domain

//     // Determine winners per metric
//     const metrics = ['domain_authority', 'page_authority', 'total_backlinks', 'referring_domains', 'domain_age_years'];
//     const spamMetric = 'spam_score'; // lower is better
//     const winners = {};
//     for (const m of metrics) {
//       let winnerRow = allRows.reduce((best, row) => (row[m] > best[m] ? row : best), allRows[0]);
//       winners[m] = winnerRow.name;
//     }
//     // Spam winner is the lowest spam score
//     let spamWinner = allRows.reduce((best, row) => (row[spamMetric] < best[spamMetric] ? row : best), allRows[0]);
//     winners.spam = spamWinner.name;

//     setRows(allRows);

//     // Generate insight text
//     const brand = allRows.find(r => r.isBrand);
//     const competitorDA = allRows.filter(r => !r.isBrand).map(r => r.domain_authority || 0);
//     const avgDA = competitorDA.reduce((a, b) => a + b, 0) / (competitorDA.length || 1);
//     let insight = '';
//     if (brand.domain_authority >= avgDA + 5) {
//       insight += `<strong>${brandName}</strong> leads with Domain Authority of <strong>${brand.domain_authority}</strong>, above the competitor average of <strong>${avgDA.toFixed(0)}</strong>. `;
//     } else if (brand.domain_authority < avgDA - 5) {
//       insight += `<strong>${brandName}</strong>'s Domain Authority (<strong>${brand.domain_authority}</strong>) falls behind the competitor average (<strong>${avgDA.toFixed(0)}</strong>). `;
//     } else {
//       insight += `<strong>${brandName}</strong>'s Domain Authority (<strong>${brand.domain_authority}</strong>) is on par with competitors. `;
//     }
//     if (brand.total_backlinks < 500) {
//       insight += `With only <strong>${brand.total_backlinks.toLocaleString()}</strong> backlinks, you have fewer than typical competitors – consider a link building campaign. `;
//     }
//     if (brand.spam_score > 6) {
//       insight += `Spam score of <strong>${brand.spam_score}%</strong> is high – audit your backlink profile. `;
//     }
//     if (brand.domain_age_years < 2) {
//       insight += `The domain is only <strong>${brand.domain_age_years}</strong> years old; trust builds over time. `;
//     }
//     setInsightText(insight);
//   };

//   // Poll until data ready, then build table
//     useEffect(() => {
//     let stopped = false;

//     const checkAndBuild = () => {
//       if (stopped) return;
//       if (isDataReady()) {
//         stopped = true;
//         buildTable();
//         setLoading(false);
//       } else {
//         setTimeout(checkAndBuild, 500);
//       }
//     };

//     checkAndBuild();

//     const fallback = setTimeout(() => {
//       if (!stopped) {
//         stopped = true;
//         buildTable();
//         setLoading(false);
//       }
//     }, 15000);

//     return () => {
//       stopped = true;
//       clearTimeout(fallback);
//     };
//   }, [websiteUrl, competitors]);

//   if (loading) {
//     return (
//       <div className="card" id="card-5">
//         <div className="eyebrow">SEO Analysis</div>
//         <h2 className="ctitle">Domain & Backlink Comparison</h2>
//         <p className="cdesc">How your brand stacks up against competitors across key SEO metrics.</p>
//         <div className="seo-fetch show">
//           <div className="spinner" />
//           <span>Fetching SEO metrics for all domains…</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="card" id="card-5">
//       <div className="eyebrow">SEO Analysis</div>
//       <h2 className="ctitle">Domain & Backlink Comparison</h2>
//       <p className="cdesc">How your brand stacks up against competitors across key SEO metrics.</p>

//       {/* <div className="c5-dev">
//         <svg width="13" height="13" viewBox="0 0 24 24" fill="#8B6DBF" style={{ flexShrink:0, marginTop:1 }}>
//           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
//         </svg>
//         <span><strong>Developer note:</strong> Metrics from Domain Authority API. Best in category highlighted.</span>
//       </div> */}

//       <div className="seo-wrap show">
//         <div className="scroll-hint">
//           <svg viewBox="0 0 24 24"><path d="M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"/></svg>
//           Scroll to see all metrics
//         </div>

//         <div className="seo-legend">
//           <div className="legend-item"><div className="metric-dot dot-good"></div> Strong</div>
//           <div className="legend-item"><div className="metric-dot dot-warn"></div> Average</div>
//           <div className="legend-item"><div className="metric-dot dot-bad"></div> Needs work</div>
//           <div className="legend-item"><span className="crown">👑</span> Best in category</div>
//         </div>

//         <div className="seo-scroll-outer">
//           <div className="seo-table-container">
//             <table className="seo-table">
//               <thead>
//                 <tr>
//                   <th>Brand / Competitor</th>
//                   <th>Domain Authority<span className="metric-hint">Score out of 100</span></th>
//                   <th>Page Authority<span className="metric-hint">Score out of 100</span></th>
//                   <th>Spam Score<span className="metric-hint">Lower is better</span></th>
//                   <th>Total Backlinks<span className="metric-hint">All inbound links</span></th>
//                   <th>Referring Domains<span className="metric-hint">Unique domains</span></th>
//                   <th>Domain Age<span className="metric-hint">Years online</span></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.map((row, idx) => {
//                   const isWinnerDA = row.domain_authority === Math.max(...rows.map(r => r.domain_authority || 0));
//                   const isWinnerPA = row.page_authority === Math.max(...rows.map(r => r.page_authority || 0));
//                   const isWinnerSpam = row.spam_score === Math.min(...rows.map(r => r.spam_score || 100));
//                   const isWinnerBacklinks = row.total_backlinks === Math.max(...rows.map(r => r.total_backlinks || 0));
//                   const isWinnerRefDomains = row.referring_domains === Math.max(...rows.map(r => r.referring_domains || 0));
//                   const isWinnerAge = row.domain_age_years === Math.max(...rows.map(r => r.domain_age_years || 0));

//                   const initials = row.name.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?';
//                   return (
//                     <tr key={row.domain} className={row.isBrand ? 'brand-row' : ''}>
//                       <td>
//                         <div className="entity-cell">
//                           <div className="entity-avatar" style={{ background: row.color }}>{initials}</div>
//                           <div>
//                             <div className="entity-name">{row.name}</div>
//                             <div className="entity-type">{row.isBrand ? 'Your Brand' : 'Competitor'}</div>
//                           </div>
//                         </div>
//                       </td>
//                       <td className={isWinnerDA ? 'winner-cell' : ''}>
//                         <div className="metric-val">
//                           <span className="metric-num">{row.domain_authority}{isWinnerDA && ' 👑'}</span>
//                           <div className={`metric-dot ${getMetricClass('da', row.domain_authority)}`}></div>
//                         </div>
//                       </td>
//                       <td className={isWinnerPA ? 'winner-cell' : ''}>
//                         <div className="metric-val">
//                           <span className="metric-num">{row.page_authority}{isWinnerPA && ' 👑'}</span>
//                           <div className={`metric-dot ${getMetricClass('pa', row.page_authority)}`}></div>
//                         </div>
//                       </td>
//                       <td className={isWinnerSpam ? 'winner-cell' : ''}>
//                         <div className="metric-val">
//                           <span className="metric-num">{row.spam_score}%{isWinnerSpam && ' 👑'}</span>
//                           <div className={`metric-dot ${getMetricClass('spam', row.spam_score)}`}></div>
//                         </div>
//                       </td>
//                       <td className={isWinnerBacklinks ? 'winner-cell' : ''}>
//                         <div className="metric-val">
//                           <span className="metric-num">{row.total_backlinks?.toLocaleString()}{isWinnerBacklinks && ' 👑'}</span>
//                           <div className={`metric-dot ${getMetricClass('backlinks', row.total_backlinks)}`}></div>
//                         </div>
//                       </td>
//                       <td className={isWinnerRefDomains ? 'winner-cell' : ''}>
//                         <div className="metric-val">
//                           <span className="metric-num">{row.referring_domains?.toLocaleString()}{isWinnerRefDomains && ' 👑'}</span>
//                           <div className={`metric-dot ${getMetricClass('refDomains', row.referring_domains)}`}></div>
//                         </div>
//                       </td>
//                       <td className={isWinnerAge ? 'winner-cell' : ''}>
//                         <div className="metric-val">
//                           <span className="metric-num">{row.domain_age_years}y{isWinnerAge && ' 👑'}</span>
//                           <div className={`metric-dot ${getMetricClass('age', row.domain_age_years)}`}></div>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="insight-box">
//           <div className="insight-header">
//             <div className="insight-title">
//               <svg viewBox="0 0 24 24"><path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/></svg>
//               SEO Insight
//             </div>
//             <button className="play-btn" onClick={() => {
//               const utterance = new SpeechSynthesisUtterance(insightText.replace(/<[^>]*>/g, ''));
//               utterance.lang = 'en-IN';
//               speechSynthesis.speak(utterance);
//             }}>
//               <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
//               Play
//             </button>
//           </div>
//           <div className="insight-text" dangerouslySetInnerHTML={{ __html: insightText }} />
//         </div>
//       </div>

//       <button className="btn" onClick={onContinue} style={{ marginTop: '20px' }}>
//         Continue to Page Speed Audit
//         <svg viewBox="0 0 24 24" fill="white"><path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/></svg>
//       </button>
//     </div>
//   );
// };

// export default DomainAuthorityPage;
// src/components/BrandAudit/Step5_SEOTable.jsx
import React, { useState, useEffect,useRef } from 'react';
import { normalizeBrandName } from '../../utils/normalizeBrandName';
import { GoogleGenerativeAI } from "@google/generative-ai";
import { auditAPI } from '../../services/api';


const CACHE_TTL = 24 * 60 * 60 * 1000;
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

// Helper: clean domain
const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim();

// Helper: get authority data from cache
const getAuthorityData = (domain) => {
  const cacheKey = `domainAuthority_${domain}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    const { ts, d } = JSON.parse(cached);
    if (Date.now() - ts < CACHE_TTL) return d;
  }
  return null;
};

// Helper: determine dot class based on metric value
const getMetricClass = (metric, value) => {
  if (metric === 'da' || metric === 'pa') {
    if (value >= 40) return 'dot-good';
    if (value >= 25) return 'dot-warn';
    return 'dot-bad';
  }
  if (metric === 'spam') {
    if (value <= 3) return 'dot-good';
    if (value <= 6) return 'dot-warn';
    return 'dot-bad';
  }
  if (metric === 'backlinks') {
    if (value >= 2000) return 'dot-good';
    if (value >= 500) return 'dot-warn';
    return 'dot-bad';
  }
  if (metric === 'refDomains') {
    if (value >= 100) return 'dot-good';
    if (value >= 40) return 'dot-warn';
    return 'dot-bad';
  }
  if (metric === 'age') {
    if (value >= 5) return 'dot-good';
    if (value >= 2) return 'dot-warn';
    return 'dot-bad';
  }
  return 'dot-warn';
};

const avatarColors = ['#6B4FA0', '#E05C4B', '#0D9488', '#1A73E8', '#C47D1A'];

// ─────────────────────────────────────────────────────────────────────────
// Gemini API wrapper (same as OverallScores)
// ─────────────────────────────────────────────────────────────────────────
const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

const callGemini = async (prompt) => {
  if (!GEMINI_API_KEY) throw new Error('REACT_APP_GEMINI_API_KEY not set in .env');
  try {
    const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });
    const result = await model.generateContent(prompt);
    const response = await result.response;
    return response.text();
  } catch (error) {
    console.error("Gemini SDK error:", error);
    throw new Error("Gemini API request failed");
  }
};

// ── AI Insight Box (reused for brand insight) ─────────────────────────────
const INSIGHT_TTL = 24 * 60 * 60 * 1000;

// const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight', autoGenerate = true }) => {
//   const [aiText, setAiText] = useState('');
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState('');
//   const generatedRef = React.useRef(false);

//   React.useEffect(() => {
//     if (!cacheKey) return;
//     try {
//       const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
//       if (cached) {
//         const { ts, text } = JSON.parse(cached);
//         if (Date.now() - ts < INSIGHT_TTL && text) {
//           setAiText(text);
//           return;
//         }
//       }
//     } catch {}
//     if (autoGenerate && !generatedRef.current) {
//       generatedRef.current = true;
//       generate();
//     }
//   }, [cacheKey]);

//   const generate = async () => {
//     if (!prompt) return;
//     setAiLoading(true);
//     setAiError('');
//     try {
//       const text = await callGemini(prompt);
//       setAiText(text);
//       if (cacheKey) {
//         localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
//       }
//     } catch (e) {
//       setAiError('Could not generate insight. Check your API key and try again.');
//       console.error(e);
//     } finally {
//       setAiLoading(false);
//     }
//   };

//   return (
//     <div className="insight-box" style={{ marginTop: 20 }}>
//       <div className="insight-header">
//         <div className="insight-title">
//           <svg viewBox="0 0 24 24" width="20" height="20">
//             <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/>
//           </svg>
//           {title}
//         </div>
//         {/* <button
//           className="play-btn"
//           onClick={generate}
//           disabled={aiLoading}
//           style={{ fontSize: 11 }}
//         >
//           {aiLoading ? 'Generating…' : (aiText ? '↺ Refresh' : '✦ Generate')}
//         </button> */}
//       </div>
//       {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight with Gemini Flash…</div>}
//       {aiError && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
//       {aiText && !aiLoading && <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>}
//       {!aiText && !aiLoading && !aiError && (
//         <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>Click "Generate" to get your AI‑powered insight.</div>
//       )}
//     </div>
//   );
// };


const AIInsightBox = ({ prompt, cacheKey, title = 'AI Insight', autoGenerate = true }) => {
  const [aiText, setAiText] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState('');
  const generatedRef = useRef(false);

  // Speech state
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const utteranceRef = useRef(null);

  useEffect(() => {
    return () => window.speechSynthesis.cancel();
  }, []);

  // Load from cache or auto‑generate
  useEffect(() => {
    if (!cacheKey) return;
    try {
      const cached = localStorage.getItem(`ai_insight_${cacheKey}`);
      if (cached) {
        const { ts, text } = JSON.parse(cached);
        if (Date.now() - ts < INSIGHT_TTL && text) {
          setAiText(text);
          return;
        }
      }
    } catch {}
    if (autoGenerate && !generatedRef.current) {
      generatedRef.current = true;
      generate();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  const generate = async () => {
    if (!prompt) return;
    setAiLoading(true);
    setAiError('');
    try {
      const text = await callGemini(prompt);
      setAiText(text);
      if (cacheKey) {
        localStorage.setItem(`ai_insight_${cacheKey}`, JSON.stringify({ ts: Date.now(), text }));
      }
    } catch (e) {
      setAiError('Could not generate insight. Check your API key and try again.');
      console.error(e);
    } finally {
      setAiLoading(false);
    }
  };

  // Single toggle: Play / Pause
  const togglePlayback = () => {
    const synth = window.speechSynthesis;

    if (isPlaying) {
      // Currently playing → pause
      synth.pause();
      setIsPlaying(false);
      setIsPaused(true);
    } else {
      // Not playing → either resume or start fresh
      if (isPaused && synth.paused) {
        synth.resume();
        setIsPlaying(true);
        setIsPaused(false);
      } else {
        // Cancel anything and start new
        synth.cancel();
        const utterance = new SpeechSynthesisUtterance(aiText.replace(/<[^>]*>/g, ''));
        utterance.lang = 'en-IN';
        utterance.onend = () => {
          setIsPlaying(false);
          setIsPaused(false);
        };
        utterance.onerror = () => {
          setIsPlaying(false);
          setIsPaused(false);
        };
        utteranceRef.current = utterance;
        synth.speak(utterance);
        setIsPlaying(true);
        setIsPaused(false);
      }
    }
  };


  return (
    <div className="insight-box" style={{ marginTop: 20 }}>
      <div className="insight-header">
        <div className="insight-title">
          <svg viewBox="0 0 24 24" width="20" height="20">
            <path d="M12 2a7 7 0 00-7 7c0 2.6 1.4 4.9 3.5 6.2V17a1 1 0 001 1h5a1 1 0 001-1v-1.8C17.6 13.9 19 11.6 19 9a7 7 0 00-7-7zm2 17h-4v1a1 1 0 001 1h2a1 1 0 001-1v-1z"/>
          </svg>
          {title}
        </div>
        {/* Single button: Play / Pause (no Stop) */}
        {aiText && !aiLoading && (
          <button className="play-btn" onClick={togglePlayback}>
            <svg viewBox="0 0 24 24" width="12" height="12">
              {isPlaying ? (
                <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" /> // Pause icon
              ) : (
                <path d="M8 5v14l11-7z" /> // Play icon
              )}
            </svg>
            {isPlaying ? 'Pause' : 'Play'}
          </button>
        )}
      </div>

      {aiLoading && <div style={{ fontSize: 13, color: '#6B4FA0' }}>Generating AI insight</div>}
      {aiError && !aiLoading && <div style={{ fontSize: 12, color: '#c62828' }}>{aiError}</div>}
      {aiText && !aiLoading && <div className="insight-text" style={{ marginTop: 8 }}>{aiText}</div>}
      {!aiText && !aiLoading && !aiError && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic' }}>AI insight will appear here shortly.</div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Main Component (Step5_SEOTable)
// ─────────────────────────────────────────────────────────────────────────
const DomainAuthorityPage = ({ brandName, websiteUrl, competitors, onContinue }) => {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [brandMetrics, setBrandMetrics] = useState(null); // store brand data for AI prompt

  const isDataReady = () => {
    const brandDomain = cleanDomain(websiteUrl);
    if (!getAuthorityData(brandDomain)) return false;
    for (const comp of competitors) {
      const compDomain = cleanDomain(comp.website);
      if (compDomain && !getAuthorityData(compDomain)) return false;
    }
    return true;
  };

  const buildTable = () => {
    const brandDomain = cleanDomain(websiteUrl);
    const brandData = getAuthorityData(brandDomain) || {};
    const normalizedBrandName = normalizeBrandName(brandName);   // normalize brand name
    setBrandMetrics(brandData);

    const allRows = [
      {
        domain: brandDomain,
        name: normalizedBrandName,
        isBrand: true,
        color: avatarColors[0],
        ...brandData,
      },
      ...competitors.map((comp, idx) => {
        const domain = cleanDomain(comp.website);
        const data = getAuthorityData(domain) || {};
        const rawName = comp.name || domain || 'Competitor';
       const normalizedCompName = normalizeBrandName(rawName); // normalize competitor name
        return {
          domain,
          name: normalizedCompName,
          isBrand: false,
          color: avatarColors[(idx + 1) % avatarColors.length],
          ...data,
        };
      }),
    ].filter(row => row.domain);

    // Determine winners per metric
    const metrics = ['domain_authority', 'page_authority', 'total_backlinks', 'referring_domains', 'domain_age_years'];
    const spamMetric = 'spam_score';
    const winners = {};
    for (const m of metrics) {
      let winnerRow = allRows.reduce((best, row) => (row[m] > best[m] ? row : best), allRows[0]);
      winners[m] = winnerRow.name;
    }
    let spamWinner = allRows.reduce((best, row) => (row[spamMetric] < best[spamMetric] ? row : best), allRows[0]);
    winners.spam = spamWinner.name;

    setRows(allRows);
  };

  // ── Fetch and cache authority if missing ──────────────────────────────────
const extractAuthorityMetrics = (response, domain) => {
  const d = response?.data;
  if (!d) return null;
  if (d.data?.domain_authority !== undefined) return d.data;
  if (d.domain_authority !== undefined) return d;
  if (d.data && typeof d.data === 'object') {
    if (d.data[domain]?.domain_authority !== undefined) return d.data[domain];
    const key = Object.keys(d.data).find(k => k !== 'insights' && d.data[k]?.domain_authority);
    if (key) return d.data[key];
  }
  if (d[domain]?.domain_authority !== undefined) return d[domain];
  if (d.success && d.data) {
    const inner = d.data;
    if (inner.domain_authority !== undefined) return inner;
    if (inner[domain]?.domain_authority !== undefined) return inner[domain];
  }
  return null;
};

const normalizeAuthorityData = (raw, domain) => {
  const cap = (v) => Math.min(Math.max(parseInt(v) || 0, 0), 100);
  return {
    domain:            raw.domain ?? domain,
    domain_authority:  cap(raw.domain_authority),
    page_authority:    cap(raw.page_authority),
    spam_score:        cap(raw.spam_score),
    spam_risk:         raw.spam_risk ?? 'UNKNOWN',
    referring_domains: parseInt(raw.referring_domains) || 0,
    total_backlinks:   parseInt(raw.total_backlinks)   || 0,
    domain_age_years:  parseFloat(raw.domain_age_years) || 0,
    source:            raw.source ?? 'unknown',
    insights:          raw.insights ?? '',
  };
};

const fetchAndCacheAuthority = async (domain) => {
  try {
    const res = await auditAPI.authorityAnalysis({ BrandURL: `https://${domain}` });
    const raw = extractAuthorityMetrics(res, domain);
    if (raw) {
      const normalized = normalizeAuthorityData(raw, domain);
      localStorage.setItem(`domainAuthority_${domain}`, JSON.stringify({ ts: Date.now(), d: normalized }));
      console.log(`✅ Fetched & cached authority for ${domain}`);
      return normalized;
    }
  } catch (e) {
    console.warn(`❌ Authority fetch failed for ${domain}:`, e);
  }
  return null;
};

  // useEffect(() => {
  //   let stopped = false;
  //   const checkAndBuild = () => {
  //     if (stopped) return;
  //     if (isDataReady()) {
  //       stopped = true;
  //       buildTable();
  //       setLoading(false);
  //     } else {
  //       setTimeout(checkAndBuild, 500);
  //     }
  //   };
  //   checkAndBuild();
  //   const fallback = setTimeout(() => {
  //     if (!stopped) {
  //       stopped = true;
  //       buildTable();
  //       setLoading(false);
  //     }
  //   }, 15000);
  //   return () => { stopped = true; clearTimeout(fallback); };
  // }, [websiteUrl, competitors]);
  useEffect(() => {
  let stopped = false;

  const run = async () => {
    const brandDomain = cleanDomain(websiteUrl);
    const allDomains = [
      brandDomain,
      ...competitors.map(c => cleanDomain(c.website)).filter(Boolean),
    ];

    // Fetch any domains missing from cache
    await Promise.all(
      allDomains.map(async (domain) => {
        if (!domain) return;
        if (!getAuthorityData(domain)) {
          console.log(`🔄 Authority cache miss — fetching: ${domain}`);
          await fetchAndCacheAuthority(domain);
        } else {
          console.log(`⚡ Authority cache hit: ${domain}`);
        }
      })
    );

    if (!stopped) {
      buildTable();
      setLoading(false);
    }
  };

  run();

  // Fallback timeout
  const fallback = setTimeout(() => {
    if (!stopped) {
      stopped = true;
      buildTable();
      setLoading(false);
    }
  }, 20000);

  return () => {
    stopped = true;
    clearTimeout(fallback);
  };
}, [websiteUrl, competitors]);

  if (loading) {
    return (
      <div className="card" id="card-5">
        <div className="eyebrow">SEO Analysis</div>
        <h2 className="ctitle">See What’s Driving Your Score</h2>
        <p className="cdesc">How your brand stacks up against competitors across key SEO metrics.</p>
        <div className="seo-fetch show">
          <div className="spinner" />
          <span>Fetching SEO metrics for all domains…</span>
        </div>
      </div>
    );
  }

  // Build brand SEO prompt using the brandMetrics (same as user's example)
const buildSeoPrompt = ({
  brandName,
  domainAuthority,
  pageAuthority,
  spamScore,
  totalBacklinks,
  referringDomains,
  domainAge,
  websiteUrl = '',
  competitors = [],
}) => {
  // Prepare competitor comparison line (top competitor by DA)
  const topComp = competitors.length > 0 ? competitors[0] : null;
  const compLine = topComp
    ? `Top competitor ${topComp.name || topComp.domain || 'rival'} has Domain Authority ${topComp.domain_authority || 0}/100.`
    : 'No competitor data for comparison.';

  return `You are a senior SEO strategist preparing a professional brand audit report.
    Use precise, business-appropriate language. No bullet points. Maximum 3 sentences.

    Brand: ${brandName}
    Domain Authority: ${domainAuthority}/100
    Page Authority: ${pageAuthority}/100
    Spam Score: ${spamScore}%
    Total Backlinks: ${totalBacklinks ? totalBacklinks.toLocaleString() : 0}
    Referring Domains: ${referringDomains ? referringDomains.toLocaleString() : 0}
    Domain Age: ${domainAge} years
    ${compLine}

    Deliver a professional assessment of this brand's domain authority and backlink profile.
    Explain the implications for organic search visibility in business terms.
    Identify the single most critical SEO gap requiring immediate attention.`;
    };

    // Then, when you call AIInsightBox, use:
    const seoPrompt = brandMetrics ? buildSeoPrompt({
      brandName: normalizeBrandName(brandName),
      domainAuthority: brandMetrics.domain_authority || 0,
      pageAuthority: brandMetrics.page_authority || 0,
      spamScore: brandMetrics.spam_score || 0,
      totalBacklinks: brandMetrics.total_backlinks || 0,
      referringDomains: brandMetrics.referring_domains || 0,
      domainAge: brandMetrics.domain_age_years || 0,
      websiteUrl,
      competitors: rows.filter(r => !r.isBrand).map(r => ({ name: r.name, domain_authority: r.domain_authority })),
    }) : '';

  return (
    <div className="card" id="card-5">
      <div className="eyebrow">SEO Analysis</div>
      <h2 className="ctitle">See What’s Driving Your Score</h2>
      <p className="cdesc">How your brand stacks up against competitors across key SEO metrics.</p>

      <div className="seo-wrap show">
        <div className="scroll-hint">
          <svg viewBox="0 0 24 24"><path d="M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"/></svg>
          Scroll to see all metrics
        </div>

        <div className="seo-legend">
          <div className="legend-item"><div className="metric-dot dot-good"></div> Strong</div>
          <div className="legend-item"><div className="metric-dot dot-warn"></div> Average</div>
          <div className="legend-item"><div className="metric-dot dot-bad"></div> Needs work</div>
          <div className="legend-item"><span className="crown">👑</span> Best in category</div>
        </div>

        <div className="seo-scroll-outer">
          <div className="seo-table-container">
            <table className="seo-table">
              {/* ... table header and body as before (unchanged) ... */}
              <thead>
                <tr>
                  <th>Brand / Competitor</th>
                  <th>Domain Authority<span className="metric-hint">Score out of 100</span></th>
                  <th>Page Authority<span className="metric-hint">Score out of 100</span></th>
                  <th>Spam Score<span className="metric-hint">Lower is better</span></th>
                  <th>Total Backlinks<span className="metric-hint">All inbound links</span></th>
                  <th>Referring Domains<span className="metric-hint">Unique domains</span></th>
                  <th>Domain Age<span className="metric-hint">Years online</span></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => {
                  const isWinnerDA = row.domain_authority === Math.max(...rows.map(r => r.domain_authority || 0));
                  const isWinnerPA = row.page_authority === Math.max(...rows.map(r => r.page_authority || 0));
                  const isWinnerSpam = row.spam_score === Math.min(...rows.map(r => r.spam_score || 100));
                  const isWinnerBacklinks = row.total_backlinks === Math.max(...rows.map(r => r.total_backlinks || 0));
                  const isWinnerRefDomains = row.referring_domains === Math.max(...rows.map(r => r.referring_domains || 0));
                  const isWinnerAge = row.domain_age_years === Math.max(...rows.map(r => r.domain_age_years || 0));
                  const initials = row.name.split(' ').slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?';
                  return (
                    <tr key={row.domain} className={row.isBrand ? 'brand-row' : ''}>
                      <td>
                        <div className="entity-cell">
                          <div className="entity-avatar" style={{ background: row.color }}>{initials}</div>
                          <div>
                            <div className="entity-name">{row.name}</div>
                            <div className="entity-type">{row.isBrand ? 'Your Brand' : 'Competitor'}</div>
                          </div>
                        </div>
                      </td>
                      <td className={isWinnerDA ? 'winner-cell' : ''}>
                        <div className="metric-val"><span className="metric-num">{row.domain_authority}{isWinnerDA && ' 👑'}</span><div className={`metric-dot ${getMetricClass('da', row.domain_authority)}`} /></div>
                      </td>
                      <td className={isWinnerPA ? 'winner-cell' : ''}>
                        <div className="metric-val"><span className="metric-num">{row.page_authority}{isWinnerPA && ' 👑'}</span><div className={`metric-dot ${getMetricClass('pa', row.page_authority)}`} /></div>
                       </td>
                      <td className={isWinnerSpam ? 'winner-cell' : ''}>
                        <div className="metric-val"><span className="metric-num">{row.spam_score}%{isWinnerSpam && ' 👑'}</span><div className={`metric-dot ${getMetricClass('spam', row.spam_score)}`} /></div>
                       </td>
                      <td className={isWinnerBacklinks ? 'winner-cell' : ''}>
                        <div className="metric-val"><span className="metric-num">{row.total_backlinks?.toLocaleString()}{isWinnerBacklinks && ' 👑'}</span><div className={`metric-dot ${getMetricClass('backlinks', row.total_backlinks)}`} /></div>
                       </td>
                      <td className={isWinnerRefDomains ? 'winner-cell' : ''}>
                        <div className="metric-val"><span className="metric-num">{row.referring_domains?.toLocaleString()}{isWinnerRefDomains && ' 👑'}</span><div className={`metric-dot ${getMetricClass('refDomains', row.referring_domains)}`} /></div>
                       </td>
                      <td className={isWinnerAge ? 'winner-cell' : ''}>
                        <div className="metric-val"><span className="metric-num">{row.domain_age_years}y{isWinnerAge && ' 👑'}</span><div className={`metric-dot ${getMetricClass('age', row.domain_age_years)}`} /></div>
                       </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── AI Insight Box for Brand Only ── */}
        <AIInsightBox
          title="Insight"
          cacheKey={`seo_brand_${cleanDomain(websiteUrl)}`}
          prompt={seoPrompt}
          autoGenerate={!!GEMINI_API_KEY}
        />
      </div>

      <button className="btn" onClick={onContinue} style={{ marginTop: '20px' }}>
        Continue to Page Speed Audit
        <svg viewBox="0 0 24 24" fill="white"><path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/></svg>
      </button>
    </div>
  );
};

export default DomainAuthorityPage;